import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appDecimal]'
})
export class DecimalDirective {
    

    private regex: RegExp = new RegExp(/^\d{0,11}(\.\d{0,2})?$/g);
    private specialKeys: Array<string> = [
        'Backspace', 'Tab', 'End', 'Home',
        'ArrowLeft', 'ArrowRight', 'Delete'
    ];

    constructor(private el: ElementRef) { }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }

        if(this.el.nativeElement.id == "discount"){
             this.regex = RegExp(/^\d{0,2}(\.\d{0,2})?$/g);
        } 

        if(this.el.nativeElement.id == "in_stock"){
            this.regex = RegExp(/^\d{0,10}$/g);
            if (['e', 'E', '.', ','].includes(event.key) || isNaN(Number(event.key))) {
                event.preventDefault();
                return;
            }
        } 

        if(this.el.nativeElement.id == "revised_quantity"){
            this.regex = RegExp(/^\d{0,11}$/g);
            if (['e', 'E', '.', ','].includes(event.key) || isNaN(Number(event.key))) {
                event.preventDefault();
                return;
            }
        } 

        // Prevent the "e" key
        if (event.key === 'e' || event.key === 'E') {
            event.preventDefault();
            return;
        }

        setTimeout(() => {
            const input = this.el.nativeElement.value;
            const position = this.el.nativeElement.selectionStart;
            const newValue = input.slice(0, position) + event.key + input.slice(position);

            if (!String(newValue).match(this.regex)) {
                event.preventDefault();
            }
        }, 0);
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent) {
        const clipboardData = event.clipboardData;
        const pastedText = clipboardData?.getData('text') || '';
        const input = this.el.nativeElement.value;
        const newValue = input + pastedText;

        if (!String(newValue).match(this.regex)) {
            event.preventDefault();
        }
    }

    @HostListener('input', ['$event'])
    onInput(event: InputEvent) {
        const input = this.el.nativeElement.value;
        if (!String(input).match(this.regex)) {
            this.el.nativeElement.value = input.slice(0, -1);
        }
    }

    @HostListener('blur', ['$event'])
    onBlur(event: FocusEvent) {
        const input = this.el.nativeElement.value;
        if (input && !isNaN(input)) {
            if(this.el.nativeElement.id == "number"){
                this.el.nativeElement.value = parseFloat(input).toFixed(2);
            }else{
                this.el.nativeElement.value = parseFloat(input);
            }

            if(this.el.nativeElement.id == "in_stock"){
                this.el.nativeElement.value = this.numberWithCommas(input);
            }

            if(this.el.nativeElement.id == "discount"){
                this.el.nativeElement.value = parseFloat(input);
           } 
        }
    }

    private numberWithCommas(value: string): string {
        let parts = value.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parts.join('.');
      }
    
}